<template>
  <div>
    <div class="card card-header list-group-item list-group-item-action active mb-3">
      <h4 class="mb-0">Cadastro da produção</h4>
    </div>
    <div class="card">

      <div style="padding:15px;">
          <vs-table
            :data="content">
            <template slot="header" >
              <h3>
                Registros
              </h3>
            </template>
            <template slot="thead">
              <vs-th>
                Serviço
              </vs-th>
              <vs-th style="width:150px;">
                Qtde. Max.
              </vs-th>
              <vs-th style="width:150px;">
               Qtde. Min
              </vs-th>
              <vs-th style="width:50px;">
               Aprovação
              </vs-th>
           </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

                <vs-td :data="tr.servicoId">
                  {{fnConcat(tr.servicoId)}}
                </vs-td>

                <vs-td :data="tr.maxHorasMes">
                  {{tr.maxHorasMes}}
                </vs-td>
                <vs-td :data="tr.minHorasMes">
                  {{tr.minHorasMes}}
                </vs-td>
                <vs-td class="text-center">
                  <a
                  class="icone-editar"
                  data-editar
                  title="Benefícios"
                  v-if="!tr.aprovada"
                  @click="fnAprova(tr.etapaId)"
                  >
                    <i class="i-circled i-small i-light"
                    :class="'icon-flag-checkered1'"
                    :style="'background:#8fc4a5;'"
                    ></i>
                  </a>                  
                  <a
                  class="icone-editar"
                  data-editar
                  title="Benefícios"
                  v-else
                  >
                    <i class="i-circled i-small i-light"
                    :class="'icon-checkbox-checked'"
                    :style="'background:#ccc; color:#888'"
                    ></i>
                  </a>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
  import { getSuccess,formatPrice,clientKey } from "@/global/utils";
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/pt-br';
  
  export default {
    data() {
      return {
        content:[],
        cadastro:{
        } ,
        servicos:{},
        incluindo:false,
        iconArea: 48 * 2,
        titulo:'',
        tipo:'',
        cadastroid:null
      }
    },

    mounted() {
      this.fnGetContratacao()
      this.fnGetServicos()
      this.fnGetPeriodos()
    },
    methods: {
      async fnGetServicos(){
        await this.$http.get('listaservicos/api/')
        .then(res=> {
          this.servicos = res.data
        })
        .catch(()=>{})
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY");
    },
      async fnGetPeriodos(){
        await this.$http.get('listaperiodos/api/')
        .then(res=> {
          this.periodos = res.data
        })
        .catch(()=>{})
    },
    formataPrice(val){
      return formatPrice(val)
    },
      async fnAprova(etapaId) {
        const metodo = "put"
        let dados = {
          aprovada: true,
          tsAprovacao: this.$moment().format(),
          EtapaId: etapaId,
          contratacaoId: this.cadastroid
        }
        await this.$http[metodo]("/etapa_12/aprova/" +etapaId, dados)
          .then(() => {
            getSuccess();
             this.fnGetContratacao()
          })
          .catch(() => {});
      },    

      async fnGetContratacao() {
        await this.$http
          .get(`contratacao/codigo/${this.$route.params.codigoContrato}/etapa_12`)
          .then((res) => {
            this.cadastro.contratacaoId = res.data.contratacaoId;
            this.cadastroid = res.data.contratacaoId
            if(res.data.contratacoesEVO12 != null){
              this.content = []
              var toString = JSON.stringify(res.data.contratacoesEVO12)
               var toJson = JSON.parse(toString)
              for(var i =0; i < toJson.length;i++){
                this.content.push(toJson[i])
              }
            }
          })
          .catch(() => {});
      },
      fnCancela(){
        this.incluindo = false;
        this.titulo = ''
        this.tipo =''

      },
      fnEdicao(val){
        if (val == 'Incluindo'){
          this.incluindo = true;
          this.titulo = 'Incluindo novo registro'
          this.tipo ='Inclusão'
        }
      },
      fnEditar(i){
       this.cadastro = this.content[i]
       this.cadastro.dataAquisicao = this.formatData(this.cadastro.dataAquisicao)
        },
      fnConcat(val){
        var item = this.servicos.filter((administracoes) => {
          return administracoes.servicoId ==val
        });
        var toString = JSON.stringify(item)
        var toJson = JSON.parse(toString)
        return toJson[0].titulo
    },
      fnConcat2(val){
        var item = this.periodos.filter((data) => {
          return data.periodoId ==val
        });
        var toString = JSON.stringify(item)
        var toJson = JSON.parse(toString)
        return toJson[0].titulo
    },
    convertToken(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);
        },
    async fnDeletar(val) {

        var token = localStorage.getItem(clientKey)
        var dataToken = this.convertToken(token)
      await this.$http.delete(`/etapa_12/${val}/${dataToken.ClienteId}`)
        .then(() => {
          let i = this.content.map(item => item.etapaId).indexOf(val) 
          this.content.splice(i, 1)
          getSuccess();
        })
        .catch(() => {});
    },


    },
  }
</script>

<style lang="scss" scoped>
.card-header {
  h4 {
    color: #fff;
    text-align: center;
  }
}
.expand-user{
  width: 120%;
}

</style>